export default {
  sentryDSN: '',
  skipNotifications: 'false'
};
